module.exports = __webpack_public_path__ + "static/media/analytics.9738e1e7.svg";